import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type ConfigClientProps = {
  type: 'OV' | 'ORDER'
}

export const ConfigClient = styled.div<ConfigClientProps>`
  display: flex;
  flex-direction: column;
  ${({ type }) =>
    type === 'ORDER' && `padding: ${theme.spacing.md} ${theme.spacing.xm} 0 ${theme.spacing.xm};`}
`
export const OrderConfig = styled.div`
  display: grid;
  gap: ${theme.spacing.sm};
`
export const TitleRow = styled('div')`
  display: flex;
  gap: ${theme.spacing.lg};
  align-items: center;

  #MaterialsInsertTitle {
    font-size: ${theme.typography.sizes.md};
    font-weight: ${theme.typography.weight.xl};
    color: ${theme.colors.neutral.black};
  }
`
type FieldWrapperProps = {
  templateColumns: string
  mediaTemplateColumns?: string
}

export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns};
  gap: ${theme.spacing.sm} ${theme.spacing.md};
  width: 100%;

  .fieldItemWrapper {
    display: flex;
    flex-direction: column;
  }

  .outerFieldItemWrapper {
    display: grid;
    grid-template-columns: 1fr;
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: ${({ templateColumns, mediaTemplateColumns }) =>
      mediaTemplateColumns ? mediaTemplateColumns : templateColumns};
  }
`
export const LabelInfos = styled('label')`
  ${({ disabled }: { disabled?: boolean }) => css`
    cursor: inherit;
    color: ${disabled ? theme.colors.neutral.mediumhover : theme.colors.neutral.high};
    font-size: ${theme.typography.sizes['2xs']};
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.lg};
  `}
`
export const DivStyled = styled('div')`
  display: flex;
  align-items: center;
  height: -webkit-fill-available;
`
export const CreditRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xm};
  flex-wrap: wrap;
`

export const CreditItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.typography.sizes['3xs']};
  min-width: 120px;

  p {
    font-size: ${theme.typography.sizes.xs};
  }
`
export const Divider = styled.div`
  width: 100%;
  min-height: 1px;
  border-radius: ${theme.shapes.borderRadius.md};
  background-color: ${theme.colors.neutral.lighthover};
`
export const FormActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
`

export const LabelWrapper = styled.div`
  display: flex;
`
